module.exports = __webpack_public_path__ + "img/fig12.a7cffd6e.jpg";